// src/api/api.js
import axios from "axios";
import { getToken, removeToken } from "../services/AuthStorage"; // 👈 Import đúng
import { clearVoucherFromLocal } from "../services/Voucher";
const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api`//"https://localhost:7212/api";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor GẮN TOKEN vào mỗi request
api.interceptors.request.use(
  (config) => {
    const token = getToken(); // 👈 Dùng hàm getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor BẮT lỗi 401 Unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Khi bị lỗi 401 => Logout
      removeToken(); // 👈 Xoá luôn token cả localStorage & sessionStorage
      clearVoucherFromLocal();
      localStorage.removeItem("checkoutForm");
      // window.location.href = "/"; // 👈 Redirect về homepage (hoặc bạn đổi sang trang login cũng được)
    }
    return Promise.reject(error);
  }
);
